import { NodeModel } from '@minoru/react-dnd-treeview';
import { EmployeeNodeModel } from '../models';

/**
 * Esta funcion se encarga de obtener todos los nodos del arbol o empleados
 * @param selectedEmployees NodeModel[]
 * @returns NodeModel[]
 */
export const getChildNodes = (selectedEmployees: NodeModel[]) => {
    let childNodes: NodeModel[] = selectedEmployees.filter(
        (employee) => employee.droppable === false
    );

    return childNodes;
};

/**
 * Esta funcion se encarga de encontrar todos los padres del arbol o grupos, areas
 * @param selectedEmployees NodeModel[]
 * @returns NodeModel[]
 */
export const getParentsNodes = (selectedEmployees: NodeModel[]) => {
    let childNodes: NodeModel[] = selectedEmployees.filter(
        (employee) => employee.droppable === true
    );

    return childNodes;
};

export function findParentsNodesByChildNode(
    tree: EmployeeNodeModel[],
    childNode: EmployeeNodeModel
) {
    const parentsNodes: EmployeeNodeModel[] = [];
    let currentNode: EmployeeNodeModel | undefined = childNode;

    // Recorrer hacia arriba en el árbol
    while (currentNode.parent !== 0) {
        //@ts-ignore
        currentNode = tree.find((node) => node.id === currentNode.parent);
        if (currentNode) {
            parentsNodes.push(currentNode);
        } else {
            break; // Romper el bucle si no se encuentra el nodo padre
        }
    }

    return parentsNodes;
}
